const dayItemSchema = {
  title: 'Jour',
  addMessage: 'Ajouter un jour',
  fieldsets: [
    {
      id: 'default',
      title: 'Jour',
      fields: ['day', 'time', 'closed'],
    },
  ],
  properties: {
    day: { title: 'Jour', type: 'string' },
    time: { title: 'Horaire', type: 'string' },
    closed: {
      title: 'Fermé',
      type: 'boolean',
      description: 'Affiche « Fermé » et applique le style alerte.',
      default: false,
    },
  },
  required: ['day'],
};

const serviceItemSchema = {
  title: 'Service',
  addMessage: 'Ajouter un service',
  fieldsets: [
    {
      id: 'default',
      title: 'Service',
      fields: ['name', 'role', 'days'],
    },
  ],
  properties: {
    name: { title: 'Nom', type: 'string' },
    role: {
      title: 'Rôle',
      type: 'string',
      description:
        '« Service » apparaît dans la grille principale ; « Repos » est affiché à côté des notes de réservation.',
      choices: [
        ['service', 'Service'],
        ['repos', 'Repos'],
      ],
      default: 'service',
    },
    days: {
      title: 'Jours',
      type: 'array',
      widget: 'object_list',
      schema: dayItemSchema,
    },
  },
  required: ['name'],
};

const schema = () => ({
  title: 'Horaires',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['eyebrow', 'heading', 'services', 'reservation_note'],
    },
  ],
  properties: {
    eyebrow: {
      title: 'Surtitre',
      type: 'string',
      default: 'Horaires',
    },
    heading: {
      title: 'Titre',
      type: 'string',
      default: 'Quand nous trouver à table.',
    },
    services: {
      title: 'Services',
      type: 'array',
      widget: 'object_list',
      schema: serviceItemSchema,
    },
    reservation_note: {
      title: 'Note sur les réservations',
      type: 'string',
      widget: 'textarea',
    },
  },
  required: [],
});

export default schema;
